export default __webpack_public_path__ + "static/media/service.36436835.png";